import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Nudjene_cijene, ApiClientService } from '../../../../services/api-client.service';

@Component({
  selector: 'app-create-nudjene-cijene',
  templateUrl: './create-nudjene-cijene.component.html',
  styleUrls: ['./create-nudjene-cijene.component.scss']
})
export class CreateNudjeneCijeneComponent {
  @Input() set visible(value: boolean) {
    this.isVisible = value;
    if (value) {
      this.initializeForm();
    }
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() nudjeneCijeneCreated = new EventEmitter<Nudjene_cijene>();

  isVisible = false;
  loading = false;
  nudjeneCijeneForm!: FormGroup;
  maxDate = new Date();

  datumEditorOptions: any = {
    placeholder: 'Odaberite datum...',
    type: 'date',
    max: this.maxDate,
    displayFormat: "dd.MM.yyyy"
  };

  tekstEditorOptions: any = {
    placeholder: 'Unesite tekst nudjenih cijena...',
    autoResizeEnabled: true,
    height: 100
  };

  constructor(
    private fb: FormBuilder, 
    private apiClient: ApiClientService
  ) {}

  onPopupShown() {
    this.initializeForm();
  }

  initializeForm() {
    this.nudjeneCijeneForm = this.fb.group({
      datum: [new Date().toISOString().split('T')[0], Validators.required],
      tekst: ['', Validators.required]
    });
  }

  onFieldDataChanged(e: any) {
    if (e.dataField && e.value !== undefined) {
      this.nudjeneCijeneForm.patchValue({
        [e.dataField]: e.value
      });
    }
  }

  onPopupHiding() {
    this.isVisible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.isVisible = false;
    this.visibleChange.emit(false);
    this.nudjeneCijeneForm.reset();
  }

  async onSubmit() {
    if (this.nudjeneCijeneForm.valid) {
      this.loading = true;

      try {
        const createdNudjeneCijene = await this.apiClient.nudjeneCijenePOST(this.nudjeneCijeneForm.value);

        this.nudjeneCijeneCreated.emit(createdNudjeneCijene);
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.nudjeneCijeneForm.reset();

      } catch (error) {
        console.error('Error creating nudjene cijene:', error);
      } finally {
        this.loading = false;
      }
    } else {
      this.markFormGroupTouched(this.nudjeneCijeneForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
}